
import PracticQuestionSubjects from '../subjects/PracticQuestionSubjects';

function DiagramQuestions() {

 
  return (

    <>
  
      <PracticQuestionSubjects 
        name="NCERT-Based Questions (DPP)" // Better for H1
        link="diagram-based-questions" 
        type="diagrambasedquestions" 
      />

     
    </>
  );
}

export default DiagramQuestions;